import cn from "classnames";

import stylesProductTile from "../../cart/cart-product-tile.module.scss";
import styles from "./skeleton-cart-product.module.scss";

export default function SkeletonCartProduct() {
  return (
    <div className={cn(stylesProductTile.container, styles.tileContainer, "pulseAnimation")}>
      <div className={cn(stylesProductTile.productLink, styles.link, styles.backgroundLightGray)}>
        <div className={styles.innerImage}></div>
      </div>
      <div className={stylesProductTile.infoContainer}>
        <p className={cn(stylesProductTile.productName, styles.name, styles.backgroundLightGray)}></p>
        <div className={cn(stylesProductTile.colorContainer, styles.color, styles.backgroundLightGray)}></div>
        <div className={cn(stylesProductTile.bottomContainer, styles.bottom)}>
          <div className={cn(stylesProductTile.actionsContainer, styles.actions)}>
            <div className={cn(styles.quantitySelector, styles.backgroundLightGray)}></div>
            <div className={styles.buttonContainer}>
              <div className={cn(styles.button, styles.backgroundLightGray)}></div>
              <div className={cn(styles.button, styles.backgroundLightGray)}></div>
            </div>
          </div>
          <div className={cn(styles.price, styles.backgroundLightGray)}></div>
        </div>
        {/* <div className={styles.discountLine}>
          <div className={cn(styles.discountLabel, styles.backgroundLightGray)}></div>
          <div className={cn(styles.discountValue, styles.backgroundLightGray)}></div>
        </div> */}
      </div>
    </div>
  );
}
